import axios from "axios";

export const fetchReadingTypes = async (machineId) => {
    const response = await axios.get(`api/SensorDataSettings/${machineId}`);
    const readingTypes = response.data;
    return readingTypes;
}

export const updateReadingType = async (readingType) => {
    try {
        const response = await axios.put(`api/SensorDataSettings/`, readingType);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

export const fetchDataTypes = async () => {
    const response = await axios.get(`api/SensorDataSettings/DataTypes`);
    const dataTypes = response.data;
    return dataTypes;
}

export const fetchSensors = async () => {
    const response = await axios.get(`api/SensorDataSettings/Sensors`);
    const sensors = response.data;
    return sensors;
}